export default __webpack_public_path__ + "static/patent-roi-calculator-d7c600c4b94a8ae81ad1ee6ff19d2a16.png";